import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PROFA1_REFERENCE_DATA_URL } from '../../../constants';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getProfA1ReferenceData = createAsyncThunk(
  'stop/getProfA1ReferenceData',
  async (params) => {
    const config = {
      headers: {
        Authorization: params,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(PROFA1_REFERENCE_DATA_URL, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const profA1ReferenceDataSlice = createSlice({
  name: 'stop/profA1ReferenceData',
  initialState: null,
  reducers: {
    resetProfA1ReferenceData: () => null,
  },
  extraReducers: {
    [getProfA1ReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetProfA1ReferenceData } =
profA1ReferenceDataSlice.actions;

export default profA1ReferenceDataSlice.reducer;
